import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import AccountModal from "@/account/components/shared/account-modal.vue";
import RegistrationContent from "./registration/registration-content.vue";

import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'registration-modal',
  setup(__props) {

const { closeAccountModal } = useAuthenticationFlows();

const isRegistrationOpened = computed(
    () =>
        authenticationStep.value == "RegPersonal" ||
        authenticationStep.value == "RegVerPhone" ||
        authenticationStep.value == "RegPinLog" ||
        authenticationStep.value == "RegPinOk" ||
        authenticationStep.value == "RegNewPass"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccountModal, {
    modelValue: isRegistrationOpened.value,
    "onUpdate:modelValue": _unref(closeAccountModal),
    class: "registration-modal"
  }, {
    default: _withCtx(() => [
      _createVNode(RegistrationContent)
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
}

})